var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarInventoryIconHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0415 17.5C1.0415 17.1548 1.32133 16.875 1.6665 16.875H18.3332C18.6783 16.875 18.9582 17.1548 18.9582 17.5C18.9582 17.8452 18.6783 18.125 18.3332 18.125H1.6665C1.32133 18.125 1.0415 17.8452 1.0415 17.5Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1665 11.4583C4.05144 11.4583 3.95817 11.5516 3.95817 11.6667V16.6667C3.95817 16.7817 4.05144 16.875 4.1665 16.875H5.83317C5.94823 16.875 6.0415 16.7817 6.0415 16.6667V11.6667C6.0415 11.5516 5.94823 11.4583 5.83317 11.4583H4.1665ZM2.70817 11.6667C2.70817 10.8612 3.36109 10.2083 4.1665 10.2083H5.83317C6.63859 10.2083 7.2915 10.8612 7.2915 11.6667V16.6667C7.2915 17.4721 6.63859 18.125 5.83317 18.125H4.1665C3.36109 18.125 2.70817 17.4721 2.70817 16.6667V11.6667Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37484 14.1667C4.37484 13.8215 4.65466 13.5417 4.99984 13.5417H5.4165C5.76168 13.5417 6.0415 13.8215 6.0415 14.1667C6.0415 14.5118 5.76168 14.7917 5.4165 14.7917H4.99984C4.65466 14.7917 4.37484 14.5118 4.37484 14.1667Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49984 2.29166C7.38478 2.29166 7.2915 2.38493 7.2915 2.49999V16.6667C7.2915 16.7817 7.38478 16.875 7.49984 16.875H15.8332C15.9482 16.875 16.0415 16.7817 16.0415 16.6667V2.49999C16.0415 2.38493 15.9482 2.29166 15.8332 2.29166H7.49984ZM6.0415 2.49999C6.0415 1.69457 6.69442 1.04166 7.49984 1.04166H15.8332C16.6386 1.04166 17.2915 1.69457 17.2915 2.49999V16.6667C17.2915 17.4721 16.6386 18.125 15.8332 18.125H7.49984C6.69442 18.125 6.0415 17.4721 6.0415 16.6667V2.49999Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 4.16666H9.1665V5.83332H10.8332V4.16666Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 4.16666H12.4998V5.83332H14.1665V4.16666Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 7.08332H9.1665V8.74999H10.8332V7.08332Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 7.08332H12.4998V8.74999H14.1665V7.08332Z",
    fill: "#2D2943"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 9.99999H12.4998V11.6667H14.1665V9.99999Z",
    fill: "#2D2943"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 12.9167H12.4998V14.5833H14.1665V12.9167Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarInventoryIconHover);
export default __webpack_public_path__ + "static/media/sidebar-inventory-icon-hover.fa8bb743.svg";
export { ForwardRef as ReactComponent };